module.exports = function() {
  return new Worker(__webpack_public_path__ + "396d773c62f8c751a0c1.worker.js");
};